var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ModuleDashboardAdminComponentVue", {
    attrs: {
      title: _vm.title,
      description: _vm.description,
      id: _vm.id,
      module: _vm.module,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }